export const translations = {
  en: {
    brand: {
      name: "OpSysDigital",
      tagline: "Powering Your Digital Future",
      parent: "A subsidiary of OpSys International",
    },
    topbar: {
      email: "info@opsysdigital.com",
    },
    nav: {
      about: "About",
      services: "Services",
      industries: "Industries",
      portfolio: "Portfolio",
      resources: "Resources",
      search: "Search",
      scheduleCall: "Schedule a call",
      // About dropdown
      whoWeAre: "Who we are",
      team: "Team",
      careers: "Careers",
    },
    // Dropdown content for services mega-menu
    servicesMega: {
      intro: "End-to-end capabilities across marketing, engineering and AI.",
      groups: [
        {
          title: "Digital Marketing",
          blurb: "Grow visibility, traffic and conversions.",
          items: [
            "Social media channel management",
            "Paid media and PPC campaigns",
            "SEO, AEO and GEO optimization",
            "Lead generation campaigns",
            "Website traffic growth",
            "Conversion improvement strategies",
            "Brand awareness and visibility",
            "Campaign performance tracking",
            "Digital reporting and analytics",
          ],
        },
        {
          title: "IT Consulting",
          blurb: "Design, build and modernize digital products.",
          items: [
            "Website design and development",
            "Mobile application development",
            "Cloud migration services",
            "Digital transformation consulting",
            "Custom portals and business systems",
            "Dashboards and reporting solutions",
            "Workflow systems",
            "Process improvement through technology",
          ],
        },
        {
          title: "AI & Automation",
          blurb: "Automate operations and customer engagement.",
          items: [
            "Business process automation",
            "Workflow automation",
            "Chatbot implementation",
            "AI agent implementation",
            "WhatsApp automation",
            "Smart support solutions",
            "Document automation",
            "Reporting automation",
            "Internal workflow optimization",
            "AI-enabled customer engagement",
          ],
        },
      ],
    },
    hero: {
      eyebrow: "Digital. Engineered.",
      headline: "A quieter way to build your digital future.",
      sub: "Strategy, engineering and AI — delivered with the craft of a senior team.",
      ctaPrimary: "Explore services",
      ctaSecondary: "Schedule a call",
      stats: [
        { value: 150, suffix: "+", label: "Projects" },
        { value: 12,  suffix: "+", label: "Years" },
        { value: 30,  suffix: "+", label: "Experts" },
        { value: 98,  suffix: "%", label: "Client Satisfaction" },
      ],
    },
    about: {
      heading: "Who we are",
      body: "OpSysDigital is the digital studio of OpSys International. We partner with enterprises and ambitious teams to design, engineer and scale products — from brand and growth through to cloud, data and AI.",
      readMore: "Learn more",
      cards: [
        { title: "Our approach",
          desc: "A small senior team. Honest scoping. Shipping work that measurably moves the business." },
        { title: "Our outlook",
          desc: "We see technology as a craft — thoughtful, well-made, and designed to last." },
        { title: "Our principles",
          desc: "Clarity over noise. Ownership over process. Outcomes over output." },
      ],
    },
    services: {
      eyebrow: "Services",
      heading: "What we do",
      sub: "Three disciplines, one accountable team.",
      learnMore: "Learn more",
    },
    industries: {
      eyebrow: "Industries",
      heading: "Who we work with",
      sub: "Deep experience across sectors that run on reliability.",
      items: [
        { title: "Hospitality",   desc: "Guest experience platforms, booking, loyalty and operations." },
        { title: "Automobile",    desc: "Dealer portals, after-sales CRM and connected-vehicle data." },
        { title: "Mobility",      desc: "Ride, fleet and logistics software for modern transport." },
        { title: "Real Estate",   desc: "Property management, leasing portals and investor dashboards." },
        { title: "EdTech",        desc: "Learning platforms, assessments and student engagement." },
        { title: "Healthcare",    desc: "Patient engagement, clinic operations and HIPAA-aware systems." },
      ],
    },
    team: {
      eyebrow: "Team",
      heading: "A senior team, by design",
      sub: "Engineers, designers and strategists who own the outcome.",
      members: [
        { name: "Ahmed Al-Rashid",   role: "CEO & Founder" },
        { name: "Sarah Mitchell",    role: "Head of Technology" },
        { name: "Omar Kassim",       role: "Creative Director" },
        { name: "Priya Nair",        role: "Client Success" },
      ],
    },
    portfolio: {
      eyebrow: "Portfolio",
      heading: "Selected work",
      sub: "A quiet sample of projects shipped with partners.",
      viewProject: "View project",
      projects: [
        { name: "Enterprise HR Portal",      tags: "Product · Web · Design" },
        { name: "Logistics Analytics Suite", tags: "Data · Dashboards · AI" },
        { name: "Retail Mobile App",         tags: "iOS · Android · Brand" },
        { name: "Hospitality Loyalty Platform", tags: "Mobile · CRM · Integrations" },
        { name: "Real-Estate Investor Portal",  tags: "Web · Dashboards · Reporting" },
        { name: "EdTech Assessment Platform",  tags: "Platform · Web · Analytics" },
      ],
    },
    resources: {
      eyebrow: "Resources",
      heading: "Insights & ideas",
      sub: "Writing from our team on strategy, engineering and design.",
      readMore: "Read",
      posts: [
        { category: "Strategy",    title: "How mid-market firms win with digital transformation", date: "Apr 12, 2026" },
        { category: "Engineering", title: "A practical guide to cloud migrations that don't stall", date: "Mar 28, 2026" },
        { category: "Design",      title: "Design systems: the quiet lever behind fast-moving teams", date: "Mar 10, 2026" },
      ],
    },
    career: {
      eyebrow: "Careers",
      heading: "Build with us",
      sub: "We hire senior people who care about craft and outcomes.",
      cultureTitle: "Culture & benefits",
      cultureBody: "Small senior team. Competitive compensation. Hybrid / remote flexibility. Real ownership on projects that ship.",
      benefits: [
        "Hybrid & remote flexibility",
        "Learning & development budget",
        "Premium health coverage",
        "Ownership on client outcomes",
      ],
      applyNow: "Apply now",
      openRoles: "Open roles",
      cvPrompt: "Don't see your role? Send us your CV",
      positions: [
        { title: "Senior Full-Stack Engineer",  department: "Engineering", location: "Dubai" },
        { title: "Product Designer (UI/UX)",    department: "Design",      location: "Remote" },
        { title: "Digital Strategy Consultant", department: "Consulting",  location: "Dubai" },
      ],
    },
    contact: {
      eyebrow: "Contact",
      heading: "Let's talk",
      sub: "Tell us about your project. We reply within one business day.",
      details: "Contact",
      address: "Business Bay, Dubai, UAE",
      email: "info@opsysdigital.com",
      phone: "+971 XX XXX XXXX",
      map: "Our office",
      form: {
        name: "Your name",
        email: "Email",
        subject: "Describe your requirements",
        message: "Message",
        submit: "Send",
        success: "Message sent — thank you.",
      },
      hoursTitle: "Office hours",
      hours: "Sun–Thu · 9:00 – 18:00 GST",
      quickTitle: "Quick links",
    },
    footer: {
      desc: "The digital studio of OpSys International — strategy, engineering and AI for modern enterprises.",
      quickLinks: "Links",
      ourServices: "Services",
      getInTouch: "Get in touch",
      rights: "All rights reserved. A subsidiary of OpSys International.",
      privacy: "Privacy",
      terms: "Terms",
    },
    chatbot: {
      title: "OpSysDigital Assistant",
      subtitle: "Here to help",
      placeholder: "Write a message…",
      greeting: "Hello — I'm the OpSysDigital assistant. How can I help today?",
      send: "Send",
      thinking: "Thinking…",
      chips: ["Our services", "Request a quote", "Careers", "Contact"],
      chipReplies: {
        "Our services": "We work across Digital Marketing, IT Consulting and AI & Automation. Happy to point you to the right team — which area is closest to your need?",
        "Request a quote": "Share a short project brief and your timeline and we'll reply within one business day. You can also use the contact form below.",
        "Careers": "We're hiring senior engineers, designers and strategists. See the Careers section, or email your CV to info@opsysdigital.com.",
        "Contact": "You can reach us at info@opsysdigital.com or via the contact form. We reply within one business day.",
      },
    },
    search: {
      placeholder: "Search OpSysDigital…",
      empty: "No results — try 'marketing', 'AI', 'industries'…",
      hint: "Press ESC to close",
    },
    language: {
      label: "Language",
      english: "English",
      arabic: "العربية",
    },
  },
  ar: {
    brand: {
      name: "أوب‌سيس ديجيتال",
      tagline: "نُشغّل مستقبلك الرقمي",
      parent: "شركة تابعة لـ OpSys International",
    },
    topbar: {
      email: "info@opsysdigital.com",
    },
    nav: {
      about: "من نحن",
      services: "الخدمات",
      industries: "القطاعات",
      portfolio: "الأعمال",
      resources: "مكتبة المعرفة",
      search: "بحث",
      scheduleCall: "حجز مكالمة",
      whoWeAre: "من نحن",
      team: "الفريق",
      careers: "الوظائف",
    },
    servicesMega: {
      intro: "قدرات متكاملة في التسويق والهندسة والذكاء الاصطناعي.",
      groups: [
        {
          title: "التسويق الرقمي",
          blurb: "نُنمّي الظهور وحركة الزيارات ومعدلات التحويل.",
          items: [
            "إدارة قنوات التواصل الاجتماعي",
            "حملات الإعلان المدفوع وPPC",
            "تحسين SEO وAEO وGEO",
            "حملات توليد العملاء المحتملين",
            "نمو حركة الموقع",
            "استراتيجيات تحسين التحويل",
            "حملات الوعي والظهور بالعلامة",
            "قياس أداء الحملات",
            "تقارير وتحليلات رقمية",
          ],
        },
        {
          title: "الاستشارات التقنية",
          blurb: "تصميم وبناء وتطوير المنتجات الرقمية.",
          items: [
            "تصميم وتطوير المواقع",
            "تطوير تطبيقات الجوال",
            "خدمات النقل إلى السحابة",
            "استشارات التحول الرقمي",
            "بوابات وأنظمة أعمال مخصصة",
            "لوحات تحكم وحلول تقارير",
            "أنظمة سير العمل",
            "تحسين العمليات عبر التقنية",
          ],
        },
        {
          title: "الذكاء الاصطناعي والأتمتة",
          blurb: "أتمتة العمليات وتجربة العملاء.",
          items: [
            "أتمتة العمليات",
            "أتمتة سير العمل",
            "تطبيق الشات بوت",
            "تطبيق وكلاء الذكاء الاصطناعي",
            "أتمتة واتساب",
            "حلول الدعم الذكي",
            "أتمتة المستندات",
            "أتمتة التقارير",
            "تحسين سير العمل الداخلي",
            "تفاعل عملاء مدعوم بالذكاء الاصطناعي",
          ],
        },
      ],
    },
    hero: {
      eyebrow: "رقميّ. بإتقان.",
      headline: "طريقة أهدأ لبناء مستقبلك الرقمي.",
      sub: "استراتيجية وهندسة وذكاء اصطناعي — بحِرفة فريق قيادي.",
      ctaPrimary: "استكشف الخدمات",
      ctaSecondary: "حجز مكالمة",
      stats: [
        { value: 150, suffix: "+", label: "مشروع" },
        { value: 12,  suffix: "+", label: "سنة" },
        { value: 30,  suffix: "+", label: "خبير" },
        { value: 98,  suffix: "%", label: "رضا العملاء" },
      ],
    },
    about: {
      heading: "من نحن",
      body: "OpSysDigital هي الاستوديو الرقمي لـ OpSys International. نصمّم ونُهندس ونُوسِّع منتجات رقمية للمؤسسات الطموحة — من العلامة والنموّ إلى السحابة والبيانات والذكاء الاصطناعي.",
      readMore: "اعرف المزيد",
      cards: [
        { title: "منهجنا", desc: "فريق قيادي صغير، تحديد نطاق واضح، وتسليم أعمال قابلة للقياس." },
        { title: "رؤيتنا", desc: "نرى التقنية حرفةً — مدروسة، متقنة، ومصمّمة لتدوم." },
        { title: "مبادئنا", desc: "الوضوح قبل الضجيج. الملكية قبل الإجراءات. النتائج قبل المخرجات." },
      ],
    },
    services: {
      eyebrow: "الخدمات",
      heading: "ماذا نقدم",
      sub: "ثلاث تخصصات، وفريق مسؤول واحد.",
      learnMore: "اعرف المزيد",
    },
    industries: {
      eyebrow: "القطاعات",
      heading: "من نعمل معهم",
      sub: "خبرة عميقة عبر قطاعات تعتمد على الموثوقية.",
      items: [
        { title: "الضيافة",    desc: "تجربة الضيف، الحجز، الولاء والتشغيل." },
        { title: "السيارات",   desc: "بوابات الوكلاء، إدارة ما بعد البيع وبيانات المركبات." },
        { title: "التنقل",     desc: "برمجيات الركوب والأساطيل واللوجستيات." },
        { title: "العقارات",   desc: "إدارة العقارات، بوابات التأجير ولوحات المستثمرين." },
        { title: "تقنيات التعليم", desc: "منصات التعلم والتقييم وتفاعل الطلاب." },
        { title: "الرعاية الصحية",  desc: "تفاعل المرضى، تشغيل العيادات وأنظمة متوافقة." },
      ],
    },
    team: {
      eyebrow: "الفريق",
      heading: "فريق قيادي بالتصميم",
      sub: "مهندسون ومصمّمون يتحمّلون مسؤولية النتيجة.",
      members: [
        { name: "أحمد الراشد",  role: "الرئيس التنفيذي والمؤسس" },
        { name: "سارة ميتشل",   role: "رئيسة التكنولوجيا" },
        { name: "عمر قاسم",    role: "المدير الإبداعي" },
        { name: "بريا نَيّر",    role: "نجاح العملاء" },
      ],
    },
    portfolio: {
      eyebrow: "الأعمال",
      heading: "أعمال مختارة",
      sub: "عيّنة هادئة من مشاريع نُفّذت مع شركائنا.",
      viewProject: "عرض المشروع",
      projects: [
        { name: "بوابة موارد بشرية",      tags: "منتج · ويب · تصميم" },
        { name: "منصّة تحليلات لوجستية",    tags: "بيانات · لوحات · ذكاء" },
        { name: "تطبيق تجزئة",            tags: "iOS · أندرويد · هوية" },
        { name: "منصة ولاء للضيافة",       tags: "جوال · CRM · تكاملات" },
        { name: "بوابة مستثمري عقارات",    tags: "ويب · لوحات · تقارير" },
        { name: "منصة تقييم تعليمي",       tags: "منصة · ويب · تحليلات" },
      ],
    },
    resources: {
      eyebrow: "مكتبة المعرفة",
      heading: "رؤى وأفكار",
      sub: "كتابات من فريقنا في الاستراتيجية والهندسة والتصميم.",
      readMore: "اقرأ",
      posts: [
        { category: "استراتيجية",  title: "كيف تفوز الشركات المتوسطة بالتحول الرقمي", date: "١٢ أبريل ٢٠٢٦" },
        { category: "هندسة",       title: "دليل عملي لنقل الأنظمة إلى السحابة", date: "٢٨ مارس ٢٠٢٦" },
        { category: "تصميم",       title: "أنظمة التصميم: رافعة هادئة للفرق السريعة", date: "١٠ مارس ٢٠٢٦" },
      ],
    },
    career: {
      eyebrow: "الوظائف",
      heading: "ابنِ معنا",
      sub: "نوظّف محترفين يهتمون بالحرفة والنتائج.",
      cultureTitle: "الثقافة والمزايا",
      cultureBody: "فريق قيادي صغير. رواتب تنافسية. مرونة هجينة/عن بُعد. ملكية حقيقية على المشاريع.",
      benefits: ["مرونة هجينة وعن بُعد", "ميزانية للتعلم", "تأمين صحي ممتاز", "ملكية على نتائج العميل"],
      applyNow: "قدّم الآن",
      openRoles: "الوظائف المتاحة",
      cvPrompt: "لم تجد وظيفتك؟ أرسل سيرتك الذاتية",
      positions: [
        { title: "مهندس برمجيات متكامل أول", department: "الهندسة",   location: "دبي" },
        { title: "مصمم منتج (UI/UX)",       department: "التصميم",    location: "عن بُعد" },
        { title: "مستشار استراتيجية رقمية",    department: "الاستشارات", location: "دبي" },
      ],
    },
    contact: {
      eyebrow: "تواصل",
      heading: "لنتحدث",
      sub: "أخبرنا عن مشروعك. نرد خلال يوم عمل.",
      details: "معلومات التواصل",
      address: "الخليج التجاري، دبي، الإمارات",
      email: "info@opsysdigital.com",
      phone: "+٩٧١ XX XXX XXXX",
      map: "مكتبنا",
      form: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        subject: "وصف متطلباتك",
        message: "الرسالة",
        submit: "إرسال",
        success: "تم إرسال الرسالة — شكراً.",
      },
      hoursTitle: "ساعات العمل",
      hours: "الأحد–الخميس · ٩:٠٠ – ١٨:٠٠ GST",
      quickTitle: "روابط سريعة",
    },
    footer: {
      desc: "الاستوديو الرقمي لـ OpSys International — استراتيجية وهندسة وذكاء اصطناعي.",
      quickLinks: "روابط",
      ourServices: "الخدمات",
      getInTouch: "تواصل",
      rights: "جميع الحقوق محفوظة. شركة تابعة لـ OpSys International.",
      privacy: "الخصوصية",
      terms: "الشروط",
    },
    chatbot: {
      title: "مساعد OpSysDigital",
      subtitle: "في خدمتك",
      placeholder: "اكتب رسالة…",
      greeting: "مرحباً — أنا مساعد OpSysDigital. كيف يمكنني مساعدتك؟",
      send: "إرسال",
      thinking: "يفكر…",
      chips: ["خدماتنا", "طلب عرض", "الوظائف", "تواصل"],
      chipReplies: {
        "خدماتنا": "نعمل في التسويق الرقمي والاستشارات التقنية والذكاء الاصطناعي والأتمتة. أيّها الأقرب إلى حاجتك؟",
        "طلب عرض": "شاركنا وصفاً مختصراً لمشروعك وجدولك الزمني وسنرد خلال يوم عمل.",
        "الوظائف": "نوظّف مهندسين ومصمّمين ومستشارين. راجع قسم الوظائف أو أرسل سيرتك إلى info@opsysdigital.com.",
        "تواصل": "تواصل معنا على info@opsysdigital.com أو عبر نموذج الاتصال.",
      },
    },
    search: {
      placeholder: "ابحث في OpSysDigital…",
      empty: "لا نتائج — جرّب 'تسويق' أو 'ذكاء'…",
      hint: "اضغط ESC للإغلاق",
    },
    language: {
      label: "اللغة",
      english: "English",
      arabic: "العربية",
    },
  },
};
